export interface IProofDocument {
    SourceRecordType?: string;
    sourceRecordType?: string;
    RecordId?: string;
    recordId?: string;
    Title?: string;
    title?: string;
    DocumentDate?: string;
    documentDate?: string;
    ProofExcerpt?: string;
    proofExcerpt?: string;
    Status?: string;
    status?: string;
}

export interface IScheduledMemberNeed {
    MemberId?: string;
    memberId?: string;
    ReferenceDate?: string;
    referenceDate?: string;
    AhcccsId?: string;
    ahcccsId?: string;
    FirstName?: string;
    firstName?: string;
    LastName?: string;
    lastName?: string;
    MemberName?: string;
    memberName?: string;
    DOB?: string;
    dob?: string;
    Age?: number;
    age?: number;
    HealthPlan?: string;
    healthPlan?: string;
    TeamName?: string;
    teamName?: string;
    PrimaryProvider?: string;
    primaryProvider?: string;
    AppointmentId?: string;
    appointmentId?: string;
    ScheduledAppointmentDate?: string;
    scheduledAppointmentDate?: string;
    AppointmentType?: string;
    appointmentType?: string;
    AppointmentStatus?: string;
    appointmentStatus?: string;
    ScheduledProvider?: string;
    scheduledProvider?: string;
    FlaggedNeedCategories?: string[];
    flaggedNeedCategories?: string[];
    NeedSummary?: string;
    needSummary?: string;
    ProofDocuments?: IProofDocument[];
    proofDocuments?: IProofDocument[];
}

export interface ITeamScheduleNeedsSummary {
    ReferenceDate?: string;
    referenceDate?: string;
    TotalScheduledMembersNext7Days?: number;
    totalScheduledMembersNext7Days?: number;
    CountOpenTcNoLicensedVisit?: number;
    countOpenTcNoLicensedVisit?: number;
    CountInTcNotDischarged?: number;
    countInTcNotDischarged?: number;
    CountExpiredOrNotMetHedis?: number;
    countExpiredOrNotMetHedis?: number;
    CountMissingConsentOrCarePlan?: number;
    countMissingConsentOrCarePlan?: number;
    CountCanceledNeedingReschedule?: number;
    countCanceledNeedingReschedule?: number;
    ScheduledMembersOpenTcNoLicensedVisit?: IScheduledMemberNeed[];
    scheduledMembersOpenTcNoLicensedVisit?: IScheduledMemberNeed[];
    ScheduledMembersInTcNotDischarged?: IScheduledMemberNeed[];
    scheduledMembersInTcNotDischarged?: IScheduledMemberNeed[];
    ScheduledMembersExpiredOrNotMetHedis?: IScheduledMemberNeed[];
    scheduledMembersExpiredOrNotMetHedis?: IScheduledMemberNeed[];
    ScheduledMembersMissingConsentOrCarePlan?: IScheduledMemberNeed[];
    scheduledMembersMissingConsentOrCarePlan?: IScheduledMemberNeed[];
    ScheduledMembersCanceledNeedingReschedule?: IScheduledMemberNeed[];
    scheduledMembersCanceledNeedingReschedule?: IScheduledMemberNeed[];
    AllScheduledMembersWithNeeds?: IScheduledMemberNeed[];
    allScheduledMembersWithNeeds?: IScheduledMemberNeed[];
}

export default class TeamScheduleNeedsSummary implements ITeamScheduleNeedsSummary {
    ReferenceDate?: string;
    referenceDate?: string;
    TotalScheduledMembersNext7Days?: number = 0;
    totalScheduledMembersNext7Days?: number = 0;
    CountOpenTcNoLicensedVisit?: number = 0;
    countOpenTcNoLicensedVisit?: number = 0;
    CountInTcNotDischarged?: number = 0;
    countInTcNotDischarged?: number = 0;
    CountExpiredOrNotMetHedis?: number = 0;
    countExpiredOrNotMetHedis?: number = 0;
    CountMissingConsentOrCarePlan?: number = 0;
    countMissingConsentOrCarePlan?: number = 0;
    CountCanceledNeedingReschedule?: number = 0;
    countCanceledNeedingReschedule?: number = 0;
    ScheduledMembersOpenTcNoLicensedVisit?: IScheduledMemberNeed[] = [];
    scheduledMembersOpenTcNoLicensedVisit?: IScheduledMemberNeed[] = [];
    ScheduledMembersInTcNotDischarged?: IScheduledMemberNeed[] = [];
    scheduledMembersInTcNotDischarged?: IScheduledMemberNeed[] = [];
    ScheduledMembersExpiredOrNotMetHedis?: IScheduledMemberNeed[] = [];
    scheduledMembersExpiredOrNotMetHedis?: IScheduledMemberNeed[] = [];
    ScheduledMembersMissingConsentOrCarePlan?: IScheduledMemberNeed[] = [];
    scheduledMembersMissingConsentOrCarePlan?: IScheduledMemberNeed[] = [];
    ScheduledMembersCanceledNeedingReschedule?: IScheduledMemberNeed[] = [];
    scheduledMembersCanceledNeedingReschedule?: IScheduledMemberNeed[] = [];
    AllScheduledMembersWithNeeds?: IScheduledMemberNeed[] = [];
    allScheduledMembersWithNeeds?: IScheduledMemberNeed[] = [];
}
